import { CoreBox, CoreTypography } from '@youscience/core';
import { Major } from '@common-types';

import { AreaProgramCard } from '@components/AreaProgramCard';

import { sxStyles, StyledProgramsWrap } from './InterestMatchedPrograms.styles';

interface InterestMatchedProgramsProps {
  programs: Major[];
}

export const InterestMatchedPrograms = ({ programs }: InterestMatchedProgramsProps) => {
  if (!programs.length) return null;

  return (
    <CoreBox data-testid="interestMatchedPrograms" sx={sxStyles.wrap}>
      <CoreTypography sx={sxStyles.title} variant="h5" component="h3">
        Programs that match your interests
      </CoreTypography>

      <StyledProgramsWrap>
        {programs.map((program) => (
          <AreaProgramCard key={program.cipCode} programCipCode={+program.cipCode} overallFit={program.overallFit} />
        ))}
      </StyledProgramsWrap>
    </CoreBox>
  );
};
